export default __webpack_public_path__ + "static/media/metric-iec.88d91a98.png";